"use client";

import { Button, Modal, Popover } from "flowbite-react";
import { useState } from "react";
import { PinInput } from "./PinInput";
import { GrCircleInformation } from "react-icons/gr";

export function LoginModal({ show, onClose, handleSubmit }) {
  const [error, setError] = useState("");
  const [emailPin, setEmailPin] = useState("");
  const [TOTP, setTOTP] = useState("");

  return (
    <div className="container z-20">
      <Modal
        show={show}
        onClose={() => {
          setError("");
          onClose();
        }}
      >
        <Modal.Header>Login confirmation</Modal.Header>
        <Modal.Body className="items-center justify-center dark:text-white">
          <form
            className="mx-auto max-w-md items-center justify-center space-y-5"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="flex items-center justify-center space-x-2">
              <span>Enter the confirmation pin sent via email</span>

              <Popover trigger="hover" content={emailPinDescription()}>
                <button>
                  <GrCircleInformation />
                </button>
              </Popover>
            </div>
            <PinInput setPin={setEmailPin} error={error} />
            <div className="flex items-center justify-center space-x-2">
              <span>Enter the confirmation from the authentificator app</span>

              <Popover trigger="hover" content={emailPinDescription()}>
                <button>
                  <GrCircleInformation />
                </button>
              </Popover>
            </div>
            <PinInput length={6} setPin={setTOTP} error={error} />
            {error && <p className="text-center text-red-500">{error}</p>}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setError(handleSubmit(emailPin, TOTP, setError));
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

function emailPinDescription() {
  return (
    <div className="w-64 text-sm text-gray-500 dark:text-gray-400">
      <div className="border-b border-gray-200 bg-gray-100 px-3 py-2 dark:border-gray-600 dark:bg-gray-700">
        <h3 className="font-semibold text-gray-900 dark:text-white"></h3>
      </div>
      <div className="px-3 py-2">
        <p>
          The email sent to you contains a 4 digit code that you need to
          introduce in the fields below
        </p>
      </div>
    </div>
  );
}
